/**
 * 该文件存放一些注册流程相关页面路由
 */

const registrationProcessRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 完善企业信息页面，注册第一步
      {
        path: '/register/enterprise',
        name: 'RegisterEnterprise',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-epinfo')
      },
      // 完善管理员信息页面,注册第二步
      {
        path: '/register/manager',
        name: 'RegisterManager',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-mginfo')
      },
      // 支付服务费页面，注册第三步
      {
        path: '/register/pay',
        name: 'RegisterPay',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-pay')
      },
      // 审核中，审核不通过页面
      {
        path: '/register-audit',
        name: 'RegisterAudit',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-audit')
      },
      // 新店入驻-缴纳保证金页面
      {
        path: '/register/pay-deposit',
        name: 'RegisterPayDeposit',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-deposit')
      },
      // 新店入驻-缴纳保证金审核页面
      {
        path: '/register/deposit-audit',
        name: 'RegisterDepositAudit',
        meta: {
          hideMenu: true
        },
        component: () => import('@/pages/register/register-deposit-audit')
      },
      // 入驻药师帮平台页面
      {
        path: '/settle-ysb-platform',
        name: 'SettleYsbPlatform',
        component: () => import('@/pages/settle-ysb-platform')
      }
    ]
  }
];

export default registrationProcessRoutes;
